// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popup {
  position: absolute;
  animation: menudown 80ms;
}
`, "",{"version":3,"sources":["webpack://./src/frontend/components/Popup.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B","sourcesContent":[".popup {\n  position: absolute;\n  animation: menudown 80ms;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
